// Table of contents:
// 1 header
// 2 forecastDeliveryScheduleInformation
// 3 dataForDeliveryForecastDespatchAdvice
// 4 articleDetail
// 5 ShippingDetail
// 6 attachment
//  6.1 additionalDocuments
// 7 Attachment dialogs
// 7.1 uploadAttachment
// 8 Delivery forecast despatch advice dialogs
// 8.1 acceptDeliveryForecastDespatchAdvice
import { DeliveryForecastDespatchAdvice } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createDeliveryForecastDespatchAdvice =
  (): DeliveryForecastDespatchAdvice => {
    return {
      // 1 header
      header: {
        enabled: true,
        title: getTranslationsForConfig(
          'deliveryForecastDespatchAdvice.header.title',
        ), // t('deliveryForecastDespatchAdvice.header.title')
        // buyer
        buyerInformation: {
          enabled: true,
          title: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.header.buyerInformation.title',
          ), // t('deliveryForecastDespatchAdvice.header.buyerInformation.title')
          externalId: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.buyerInformation.labels.externalId',
            ), // t('deliveryForecastDespatchAdvice.header.buyerInformation.labels.externalId')
          },
          company: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.buyerInformation.labels.company',
            ), // t('deliveryForecastDespatchAdvice.header.buyerInformation.labels.company')
          },
          department: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.buyerInformation.labels.department',
            ), // t('deliveryForecastDespatchAdvice.header.buyerInformation.labels.department')
          },
          name: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.buyerInformation.labels.name',
            ), // t('deliveryForecastDespatchAdvice.header.buyerInformation.labels.name')
          },
          phone: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.buyerInformation.labels.phone',
            ), // t('deliveryForecastDespatchAdvice.header.buyerInformation.labels.phone')
          },
          email: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.buyerInformation.labels.email',
            ), // t('deliveryForecastDespatchAdvice.header.buyerInformation.labels.email')
          },
          address: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.buyerInformation.labels.address',
            ), // t('deliveryForecastDespatchAdvice.header.buyerInformation.labels.address')
          },
          countryCode: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.buyerInformation.labels.countryCode',
            ), // t('deliveryForecastDespatchAdvice.header.buyerInformation.labels.countryCode')
          },
          vatNumber: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.buyerInformation.labels.vatNumber',
            ), // t('deliveryForecastDespatchAdvice.header.buyerInformation.labels.vatNumber')
          },
        },
        // seller
        sellerInformation: {
          enabled: true,
          title: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.header.sellerInformation.title',
          ), // t('deliveryForecastDespatchAdvice.header.sellerInformation.title')
          externalId: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.sellerInformation.labels.externalId',
            ), // t('deliveryForecastDespatchAdvice.header.sellerInformation.labels.externalId')
          },
          company: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.sellerInformation.labels.company',
            ), // t('deliveryForecastDespatchAdvice.header.sellerInformation.labels.company')
          },
          department: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.sellerInformation.labels.department',
            ), // t('deliveryForecastDespatchAdvice.header.sellerInformation.labels.department')
          },
          name: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.sellerInformation.labels.name',
            ), // t('deliveryForecastDespatchAdvice.header.sellerInformation.labels.name')
          },
          phone: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.sellerInformation.labels.phone',
            ), // t('deliveryForecastDespatchAdvice.header.sellerInformation.labels.phone')
          },
          email: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.sellerInformation.labels.email',
            ), // t('deliveryForecastDespatchAdvice.header.sellerInformation.labels.email')
          },
          address: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.sellerInformation.labels.address',
            ), // t('deliveryForecastDespatchAdvice.header.sellerInformation.labels.address')
          },
          countryCode: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.sellerInformation.labels.countryCode',
            ), // t('deliveryForecastDespatchAdvice.header.sellerInformation.labels.countryCode')
          },
          vatNumber: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.sellerInformation.labels.vatNumber',
            ), // t('deliveryForecastDespatchAdvice.header.sellerInformation.labels.vatNumber')
          },
        },
        // shipping
        shippingInformation: {
          enabled: true,
          title: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.header.shippingInformation.title',
          ), // t('deliveryForecastDespatchAdvice.header.shippingInformation.title')
          externalId: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.shippingInformation.labels.externalId',
            ), // t('deliveryForecastDespatchAdvice.header.shippingInformation.labels.externalId')
          },
          company: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.shippingInformation.labels.company',
            ), // t('deliveryForecastDespatchAdvice.header.shippingInformation.labels.company')
          },
          department: {
            enabled: false,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.shippingInformation.labels.department',
            ), // t('deliveryForecastDespatchAdvice.header.shippingInformation.labels.department')
          },
          name: {
            enabled: false,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.shippingInformation.labels.name',
            ), // t('deliveryForecastDespatchAdvice.header.shippingInformation.labels.name')
          },
          phone: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.shippingInformation.labels.phone',
            ), // t('deliveryForecastDespatchAdvice.header.shippingInformation.labels.phone')
          },
          email: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.shippingInformation.labels.email',
            ), // t('deliveryForecastDespatchAdvice.header.shippingInformation.labels.email')
          },
          address: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.shippingInformation.labels.address',
            ), // t('deliveryForecastDespatchAdvice.header.shippingInformation.labels.address')
          },
          countryCode: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.shippingInformation.labels.countryCode',
            ), // t('deliveryForecastDespatchAdvice.header.shippingInformation.labels.countryCode')
          },
          vatNumber: {
            enabled: false,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.shippingInformation.labels.vatNumber',
            ), // t('deliveryForecastDespatchAdvice.header.shippingInformation.labels.vatNumber')
          },
          plant: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.shippingInformation.labels.plant',
            ), // t('deliveryForecastDespatchAdvice.header.shippingInformation.labels.plant')
          },
          unloadingPoint: {
            enabled: true,
            label: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.header.shippingInformation.labels.unloadingPoint',
            ), // t('deliveryForecastDespatchAdvice.header.shippingInformation.labels.unloadingPoint')
          },
        },
      },
      // 2 forecastDeliveryScheduleInformation
      forecastDeliveryScheduleInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'deliveryForecastDespatchAdvice.forecastDeliveryScheduleInformation.title',
        ), // t('deliveryForecastDespatchAdvice.forecastDeliveryScheduleInformation.title')
        orderId: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.forecastDeliveryScheduleInformation.form.orderId.label',
          ), // t('deliveryForecastDespatchAdvice.forecastDeliveryScheduleInformation.form.orderId.label')
        },
        orderDate: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.forecastDeliveryScheduleInformation.form.orderDate.label',
          ), // t('deliveryForecastDespatchAdvice.forecastDeliveryScheduleInformation.form.orderDate.label')
        },
        currentReleaseNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.forecastDeliveryScheduleInformation.form.currentReleaseNumber.label',
          ), // t('deliveryForecastDespatchAdvice.forecastDeliveryScheduleInformation.form.currentReleaseNumber.label')
        },
        orderNotes: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.forecastDeliveryScheduleInformation.form.orderNotes.label',
          ), // t('deliveryForecastDespatchAdvice.forecastDeliveryScheduleInformation.form.orderNotes.label')
        },
      },
      // 3 dataForDeliveryForecastDespatchAdvice
      dataForDeliveryForecastDespatchAdvice: {
        enabled: true,
        title: getTranslationsForConfig(
          'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.title',
        ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.title')
        deliveryNoteNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.deliveryNoteNumber.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.deliveryNoteNumber.label')
          validation: {
            isRequired: true,
          },
        },
        deliveryDate: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.deliveryDate.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.deliveryDate.label')
          validation: {
            isRequired: true,
          },
        },
        deliveryType: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.deliveryType.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.deliveryType.label')
        },
        confirmationCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationCode.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationCode.label')
        },
        confirmationId: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationId.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationId.label')
        },
        confirmationDate: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationDate.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationDate.label')
        },
        termsOfDeliveryCode: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.label')
          readonly: false,
          options: [
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.exw',
              ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.exw')
              code: 'exw',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.fca',
              ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.fca')
              code: 'fca',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.fas',
              ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.fas')
              code: 'fas',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.fob',
              ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.fob')
              code: 'fob',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.cfr',
              ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.cfr')
              code: 'cfr',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.cif',
              ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.cif')
              code: 'cif',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.dap',
              ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.dap')
              code: 'dap',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.dpu',
              ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.dpu')
              code: 'dpu',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.cpt',
              ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.cpt')
              code: 'cpt',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.cip',
              ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.cip')
              code: 'cip',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.ddp',
              ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.termsOfDelivery.options.ddp')
              code: 'ddp',
            },
          ],
          validation: {},
        },
        confirmationGrossWeight: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationGrossWeight.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationGrossWeight.label')
          readonly: false,
          validation: {},
        },
        confirmationGrossWeightUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationGrossWeightUnit.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationGrossWeightUnit.label')
          readonly: false,
          options: [
            {
              code: 'KG',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationGrossWeightUnit.options.KG',
              ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationGrossWeightUnit.options.KG')
            },
          ],
          validation: {},
        },
        confirmationNumberOfUnits: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationNumberOfUnits.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.confirmationNumberOfUnits.label')
          readonly: false,
          validation: {},
        },
        plant: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.plant.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.plant.label')
        },
        unloadingPoint: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.unloadingPoint.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.unloadingPoint.label')
        },
        gln: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.gln.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.gln.label')
          readonly: false,
          validation: {},
        },
        company: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.company.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.company.label')
          readonly: false,
          validation: {},
        },
        department: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.department.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.department.label')
          readonly: false,
          validation: {},
        },
        name: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.contactName.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.contactName.label')
          readonly: false,
          validation: {},
        },
        phone: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.contactPhone.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.contactPhone.label')
          readonly: false,
          validation: {
            regex: '^[0-9+() -]*$',
            regexErrorMessage: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.contactPhone.errorMessage',
            ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.contactPhone.errorMessage')
          },
        },
        email: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.contactMail.label',
          ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.contactMail.label')
          readonly: false,
          validation: {
            regex: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$',
            regexErrorMessage: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.contactMail.errorMessage',
            ), // t('deliveryForecastDespatchAdvice.dataForDeliveryForecastDespatchAdvice.form.contactMail.errorMessage')
          },
        },
      },
      // 4 articleDetail
      articleDetail: {
        enabled: true,
        title: getTranslationsForConfig(
          'deliveryForecastDespatchAdvice.articleDetail.title',
        ), // t('deliveryForecastDespatchAdvice.articleDetail.title')
        desAdvPosition: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.form.desAdvPosition.label',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.form.desAdvPosition.label')
        },
        buyerProductId: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.form.buyerProductId.label',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.form.buyerProductId.label')
        },
        buyerProductDescription: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.form.buyerProductDescription.label',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.form.buyerProductDescription.label')
        },
        confirmationItemId: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.form.confirmationItemId.label',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationItemId.label')
        },
        quantity: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.form.quantity.label',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.form.quantity.label')
        },
        openQuantity: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.form.openQuantity.label',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.form.openQuantity.label')
        },
        confirmationQuantity: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.form.confirmationQuantity.label',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationQuantity.label')
          validation: {
            isRequired: true,
          },
        },
        deliveryStatus: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.form.deliveryStatus.label',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.form.deliveryStatus.label')
          options: [
            {
              name: getTranslationsForConfig(
                'despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.options.partly',
              ), // t('despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.options.partly')
              code: 'PARTLY',
            },
            {
              name: getTranslationsForConfig(
                'despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.options.completed',
              ), // t('despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.options.completed')
              code: 'COMPLETE',
            },
          ],
          placeholder: getTranslationsForConfig(
            'despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.placeholder',
          ), // t('despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.placeholder')
          readonly: false,
          validation: {
            isRequired: true,
          },
        },
        confirmationNetWeight: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.form.confirmationNetWeight.label',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationNetWeight.label')
          validation: {},
        },
        confirmationNetWeightUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.form.confirmationNetWeightUnit.label',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationNetWeightUnit.label')
          options: [
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationNetWeightUnit.options.KG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationNetWeightUnit.options.KG')
              code: 'KG',
            },
          ],
          validation: {},
        },
        lastReceivingDate: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.form.lastReceivingDate.label',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.form.lastReceivingDate.label')
        },
        lastReceivingQuantity: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.form.lastReceivingQuantity.label',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.form.lastReceivingQuantity.label')
        },
        confirmationCountryOfOrigin: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.label',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.label')
          options: [
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AD',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AD')",
              code: 'AD',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AE')",
              code: 'AE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AF',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AF')",
              code: 'AF',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AG')",
              code: 'AG',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AI',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AI')",
              code: 'AI',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AL',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AL')",
              code: 'AL',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AM')",
              code: 'AM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AO',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AO')",
              code: 'AO',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AQ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AQ')",
              code: 'AQ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AR')",
              code: 'AR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AS',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AS')",
              code: 'AS',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AT',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AT')",
              code: 'AT',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AU',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AU')",
              code: 'AU',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AW',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AW')",
              code: 'AW',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AX',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AX')",
              code: 'AX',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AZ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.AZ')",
              code: 'AZ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BA',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BA')",
              code: 'BA',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BB',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BB')",
              code: 'BB',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BD',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BD')",
              code: 'BD',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BE')",
              code: 'BE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BF',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BF')",
              code: 'BF',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BG')",
              code: 'BG',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BH',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BH')",
              code: 'BH',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BI',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BI')",
              code: 'BI',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BJ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BJ')",
              code: 'BJ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BL',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BL')",
              code: 'BL',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BM')",
              code: 'BM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BN',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BN')",
              code: 'BN',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BO',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BO')",
              code: 'BO',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BQ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BQ')",
              code: 'BQ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BR')",
              code: 'BR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BS',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BS')",
              code: 'BS',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BT',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BT')",
              code: 'BT',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BV',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BV')",
              code: 'BV',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BW',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BW')",
              code: 'BW',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BY',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BY')",
              code: 'BY',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BZ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.BZ')",
              code: 'BZ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CA',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CA')",
              code: 'CA',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CC',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CC')",
              code: 'CC',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CD',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CD')",
              code: 'CD',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CF',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CF')",
              code: 'CF',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CG')",
              code: 'CG',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CH',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CH')",
              code: 'CH',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CI',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CI')",
              code: 'CI',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CK',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CK')",
              code: 'CK',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CL',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CL')",
              code: 'CL',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CM')",
              code: 'CM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CN',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CN')",
              code: 'CN',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CO',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CO')",
              code: 'CO',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CR')",
              code: 'CR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CU',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CU')",
              code: 'CU',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CV',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CV')",
              code: 'CV',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CW',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CW')",
              code: 'CW',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CX',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CX')",
              code: 'CX',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CY',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CY')",
              code: 'CY',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CZ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.CZ')",
              code: 'CZ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.DE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.DE')",
              code: 'DE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.DJ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.DJ')",
              code: 'DJ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.DK',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.DK')",
              code: 'DK',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.DM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.DM')",
              code: 'DM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.DO',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.DO')",
              code: 'DO',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.DZ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.DZ')",
              code: 'DZ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.EC',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.EC')",
              code: 'EC',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.EE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.EE')",
              code: 'EE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.EG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.EG')",
              code: 'EG',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.EH',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.EH')",
              code: 'EH',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ER',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ER')",
              code: 'ER',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ES',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ES')",
              code: 'ES',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ET',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ET')",
              code: 'ET',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.FI',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.FI')",
              code: 'FI',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.FJ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.FJ')",
              code: 'FJ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.FK',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.FK')",
              code: 'FK',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.FM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.FM')",
              code: 'FM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.FO',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.FO')",
              code: 'FO',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.FR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.FR')",
              code: 'FR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GA',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GA')",
              code: 'GA',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GB',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GB')",
              code: 'GB',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GD',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GD')",
              code: 'GD',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GE')",
              code: 'GE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GF',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GF')",
              code: 'GF',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GG')",
              code: 'GG',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GH',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GH')",
              code: 'GH',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GI',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GI')",
              code: 'GI',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GL',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GL')",
              code: 'GL',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GM')",
              code: 'GM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GN',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GN')",
              code: 'GN',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GP',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GP')",
              code: 'GP',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GQ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GQ')",
              code: 'GQ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GR')",
              code: 'GR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GS',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GS')",
              code: 'GS',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GT',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GT')",
              code: 'GT',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GU',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GU')",
              code: 'GU',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GW',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GW')",
              code: 'GW',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GY',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.GY')",
              code: 'GY',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.HK',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.HK')",
              code: 'HK',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.HM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.HM')",
              code: 'HM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.HN',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.HN')",
              code: 'HN',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.HR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.HR')",
              code: 'HR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.HT',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.HT')",
              code: 'HT',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.HU',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.HU')",
              code: 'HU',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ID',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ID')",
              code: 'ID',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IE')",
              code: 'IE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IL',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IL')",
              code: 'IL',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IM')",
              code: 'IM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IN',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IN')",
              code: 'IN',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IO',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IO')",
              code: 'IO',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IQ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IQ')",
              code: 'IQ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IR')",
              code: 'IR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IS',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IS')",
              code: 'IS',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IT',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.IT')",
              code: 'IT',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.JE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.JE')",
              code: 'JE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.JM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.JM')",
              code: 'JM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.JO',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.JO')",
              code: 'JO',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.JP',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.JP')",
              code: 'JP',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KE')",
              code: 'KE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KG')",
              code: 'KG',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KH',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KH')",
              code: 'KH',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KI',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KI')",
              code: 'KI',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KM')",
              code: 'KM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KN',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KN')",
              code: 'KN',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KP',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KP')",
              code: 'KP',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KR')",
              code: 'KR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KW',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KW')",
              code: 'KW',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KY',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KY')",
              code: 'KY',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KZ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.KZ')",
              code: 'KZ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LA',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LA')",
              code: 'LA',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LB',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LB')",
              code: 'LB',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LC',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LC')",
              code: 'LC',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LI',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LI')",
              code: 'LI',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LK',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LK')",
              code: 'LK',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LR')",
              code: 'LR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LS',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LS')",
              code: 'LS',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LT',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LT')",
              code: 'LT',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LU',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LU')",
              code: 'LU',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LV',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LV')",
              code: 'LV',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LY',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.LY')",
              code: 'LY',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MA',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MA')",
              code: 'MA',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MC',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MC')",
              code: 'MC',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MD',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MD')",
              code: 'MD',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ME',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ME')",
              code: 'ME',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MF',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MF')",
              code: 'MF',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MG')",
              code: 'MG',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MH',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MH')",
              code: 'MH',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MK',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MK')",
              code: 'MK',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ML',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ML')",
              code: 'ML',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MM')",
              code: 'MM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MN',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MN')",
              code: 'MN',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MO',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MO')",
              code: 'MO',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MP',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MP')",
              code: 'MP',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MQ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MQ')",
              code: 'MQ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MR')",
              code: 'MR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MS',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MS')",
              code: 'MS',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MT',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MT')",
              code: 'MT',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MU',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MU')",
              code: 'MU',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MV',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MV')",
              code: 'MV',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MW',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MW')",
              code: 'MW',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MX',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MX')",
              code: 'MX',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MY',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MY')",
              code: 'MY',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MZ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.MZ')",
              code: 'MZ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NA',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NA')",
              code: 'NA',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NC',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NC')",
              code: 'NC',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NE')",
              code: 'NE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NF',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NF')",
              code: 'NF',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NG')",
              code: 'NG',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NI',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NI')",
              code: 'NI',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NL',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NL')",
              code: 'NL',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NO',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NO')",
              code: 'NO',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NP',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NP')",
              code: 'NP',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NR')",
              code: 'NR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NU',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NU')",
              code: 'NU',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NZ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.NZ')",
              code: 'NZ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.OM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.OM')",
              code: 'OM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PA',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PA')",
              code: 'PA',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PE')",
              code: 'PE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PF',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PF')",
              code: 'PF',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PG')",
              code: 'PG',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PH',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PH')",
              code: 'PH',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PK',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PK')",
              code: 'PK',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PL',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PL')",
              code: 'PL',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PM')",
              code: 'PM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PN',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PN')",
              code: 'PN',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PR')",
              code: 'PR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PS',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PS')",
              code: 'PS',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PT',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PT')",
              code: 'PT',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PW',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PW')",
              code: 'PW',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PY',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.PY')",
              code: 'PY',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.QA',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.QA')",
              code: 'QA',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.RE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.RE')",
              code: 'RE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.RO',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.RO')",
              code: 'RO',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.RS',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.RS')",
              code: 'RS',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.RU',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.RU')",
              code: 'RU',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.RW',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.RW')",
              code: 'RW',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SA',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SA')",
              code: 'SA',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SB',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SB')",
              code: 'SB',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SC',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SC')",
              code: 'SC',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SD',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SD')",
              code: 'SD',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SE')",
              code: 'SE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SG')",
              code: 'SG',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SH',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SH')",
              code: 'SH',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SI',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SI')",
              code: 'SI',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SJ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SJ')",
              code: 'SJ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SK',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SK')",
              code: 'SK',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SL',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SL')",
              code: 'SL',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SM')",
              code: 'SM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SN',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SN')",
              code: 'SN',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SO',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SO')",
              code: 'SO',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SR')",
              code: 'SR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SS',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SS')",
              code: 'SS',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ST',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ST')",
              code: 'ST',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SV',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SV')",
              code: 'SV',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SX',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SX')",
              code: 'SX',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SY',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SY')",
              code: 'SY',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SZ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.SZ')",
              code: 'SZ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TC',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TC')",
              code: 'TC',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TD',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TD')",
              code: 'TD',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TF',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TF')",
              code: 'TF',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TG')",
              code: 'TG',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TH',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TH')",
              code: 'TH',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TJ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TJ')",
              code: 'TJ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TK',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TK')",
              code: 'TK',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TL',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TL')",
              code: 'TL',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TM')",
              code: 'TM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TN',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TN')",
              code: 'TN',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TO',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TO')",
              code: 'TO',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TR',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TR')",
              code: 'TR',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TT',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TT')",
              code: 'TT',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TV',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TV')",
              code: 'TV',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TW',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TW')",
              code: 'TW',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TZ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.TZ')",
              code: 'TZ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.UA',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.UA')",
              code: 'UA',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.UG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.UG')",
              code: 'UG',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.UM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.UM')",
              code: 'UM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.US',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.US')",
              code: 'US',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.UY',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.UY')",
              code: 'UY',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.UZ',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.UZ')",
              code: 'UZ',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VA',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VA')",
              code: 'VA',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VC',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VC')",
              code: 'VC',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VE')",
              code: 'VE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VG',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VG')",
              code: 'VG',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VI',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VI')",
              code: 'VI',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VN',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VN')",
              code: 'VN',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VU',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.VU')",
              code: 'VU',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.WF',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.WF')",
              code: 'WF',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.WS',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.WS')",
              code: 'WS',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.YE',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.YE')",
              code: 'YE',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.YT',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.YT')",
              code: 'YT',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ZA',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ZA')",
              code: 'ZA',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ZM',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ZM')",
              code: 'ZM',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ZW',
              ), // t('deliveryForecastDespatchAdvice.articleDetail.form.confirmationCountryOfOrigin.options.ZW')",
              code: 'ZW',
            },
          ],
          validation: {},
        },
        // ConfirmationBatches
        confirmationBatches: {
          enabled: true,
          title: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.title',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.title')

          table: {
            enabled: true,
            columns: [
              {
                // Batchnumber
                dataType: 'string',
                field: 'Batchnumber',
                width: '35%',
                // filter: true,
                // filterPlaceholder: getTranslationsForConfig(
                //   'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.columns.batchnumber.filterPlaceholder',
                // ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.columns.batchnumber.filterPlaceholder')
                header: getTranslationsForConfig(
                  'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.columns.batchnumber.header',
                ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.columns.batchnumber.header')
                // sortable: true,
              },
              {
                // Quantity
                dataType: 'number',
                field: 'Quantity',
                align: 'right',
                width: '35%',
                // filter: true,
                header: getTranslationsForConfig(
                  'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.columns.quantity.header',
                ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.columns.quantity.header')
                // sortable: true,
              },
            ],
            emptyMessageDetails: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageDetails',
            ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageDetails')
            emptyMessageTitle: getTranslationsForConfig(
              'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageTitle',
            ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageTitle')
            paginator: true,
            rows: 20,
            rowsPerPageOptions: [20, 50, 100],
            // sortField: 'Id',
            // sortOrder: 1,
            // scrollHeight: '70vh',
          },
        },
      },
      // addConfirmationBatch
      addConfirmationBatch: {
        enabled: true,
        batchnumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.columns.batchnumber.header',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.columns.batchnumber.header')
          validation: {
            isRequired: true,
          },
        },
        quantity: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.columns.quantity.header',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.columns.quantity.header')
          validation: {
            isRequired: true,
          },
        },
      },
      // 5 ShippingDetail
      shippingDetails: {
        enabled: true,
        title: getTranslationsForConfig(
          'deliveryForecastDespatchAdvice.shippingDetails.title',
        ), // t('deliveryForecastDespatchAdvice.shippingDetails.title')
        packagingTable: {
          enabled: true,
          title: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.title',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.title')
          columns: [
            {
              enabled: true,
              field: 'Position',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.position.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.position.header')
            },
            {
              enabled: true,
              field: 'PackagingType',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.label.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.label.header')
            },
            {
              enabled: true,
              field: 'PackagingId',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.packagingId.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.packagingId.header' )
            },
            {
              enabled: true,
              field: 'PackagingData.Description',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.description.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.description.header')
            },
            {
              enabled: true,
              field: 'HuNumber',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.huNumber.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.huNumber.header')
            },
            {
              enabled: true,
              field: 'IsOuterPackaging',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.isOuterPackaging.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.isOuterPackaging.header')
            },
            {
              enabled: true,
              field: 'PackagingData.TareWeight.Value',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.tareWeight.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.tareWeight.header')
            },
            {
              enabled: true,
              field: 'Batchnumber',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.batches.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.batches.header')
            },
            {
              enabled: true,
              field: 'Quantity.Value',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.quantity.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.quantity.header')
            },
            {
              enabled: true,
              field: 'Weight.Value',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.weight.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.columns.weight.header')
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.emptyMessageDetails',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.emptyMessageTitle',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.emptyMessageTitle')
          paginator: true,
          rows: 5,
          rowsPerPageOptions: [5, 20, 50],
          sortField: 'Position',
          sortOrder: 1,
        },
      },
      // addPackagingItem
      addPackagingItem: {
        label: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.label.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.label.label')
          options: [
            {
              code: 'Master',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.label.options.Master',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.label.options.Master')
            },
            {
              code: 'Single',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.label.options.Single',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.label.options.Single')
            },
            {
              code: 'Helper',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.label.options.Helper',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.label.options.Helper')
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        huNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.huNumber.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.huNumber.label')
          validation: {
            isRequired: false,
          },
        },
        isOuterPackaging: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.isOuterPackaging.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.isOuterPackaging.label')
          validation: {
            isRequired: false,
          },
        },
        selectMaster: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.selectMaster.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.selectMaster.label')
        },
        quantity: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.quantity.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.quantity.label')
          validation: {
            isRequired: true,
          },
        },
        quantityUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.quantityUnit.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.quantityUnit.label')
          options: [
            {
              code: 'PC',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.quantityUnit.options.PC',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.quantityUnit.options.PC')
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        weight: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.weight.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.weight.label')
          validation: {
            isRequired: false,
          },
        },
        weightUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.weightUnit.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.weightUnit.label')
          options: [
            {
              code: 'KG',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.weightUnit.options.KG',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.form.weightUnit.options.KG')
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        batchTable: {
          enabled: true,
          columns: [
            {
              // Batchnumber
              field: 'Batchnumber',

              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.batches.table.columns.batchnumber.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.batches.table.columns.batchnumber.header')
            },
            {
              // Quantity
              field: 'Quantity',
              align: 'right',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.batches.table.columns.quantity.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.batches.table.columns.quantity.header')
            },
            {
              // AvailableQuantity
              field: 'AvailableQuantity',
              align: 'right',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.batches.table.columns.openQuantity.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.batches.table.columns.openQuantity.header')
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageDetails',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageTitle',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageTitle')
          paginator: true,
          rows: 20,
          rowsPerPageOptions: [20, 50, 100],
        },
        packagingTable: {
          enabled: true,
          columns: [
            {
              // PackagingDataId
              field: 'PackagingDataId',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingDataId.filterPlaceholder',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingDataId.filterPlaceholder')
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingDataId.header',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingDataId.header')
              sortable: true,
            },
            {
              // Description
              field: 'Description',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.description.filterPlaceholder',
              ), // t(''masterDataManagement.packagingData.table.columns.description.filterPlaceholder')
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.description.header',
              ), // t(''masterDataManagement.packagingData.table.columns.description.header')
              sortable: true,
            },
            {
              // Type
              field: 'PackagingMaterial',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingMaterial.filterPlaceholder',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingMaterial.filterPlaceholder')
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingMaterial.header',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingMaterial.header')
              sortable: true,
            },
            {
              // TareWeight
              align: 'right',
              field: 'TareWeight.Value',
              filter: true,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.tareWeight.header',
              ), // t(''masterDataManagement.packagingData.table.columns.tareWeight.header')
              sortable: true,
            },
            {
              // TareWeightUnit
              field: 'TareWeight.Unit',
              filter: false,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.tareWeightUnit.header',
              ), // t(''masterDataManagement.packagingData.table.columns.tareWeightUnit.header')
              sortable: false,
            },
            {
              // PackagingIdentifier
              field: 'PackagingIdentifier',
              filter: true,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingIdentifier.header',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingIdentifier.header')
              sortable: true,
            },
            {
              // PropertyIdentifier
              field: 'PropertyIdentifier',
              filter: true,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.propertyIdentifier.header',
              ), // t(''masterDataManagement.packagingData.table.columns.propertyIdentifier.header')
              sortable: true,
            },
            {
              // Stackable
              align: 'center',
              field: 'IsStackable',
              filter: true,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.isStackable.header',
              ), // t(''masterDataManagement.packagingData.table.columns.isStackable.header')
              sortable: true,
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.emptyMessageDetails',
          ), // t(''masterDataManagement.packagingData.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.emptyMessageTitle',
          ), // t(''masterDataManagement.packagingData.table.emptyMessageTitle')
          paginator: true,
          rows: 20,
          rowsPerPageOptions: [20, 50, 100],
          sortField: 'PackagingDataId',
          sortOrder: 1,
          scrollHeight: '70vh',
        },
      },
      // InfoPackagingItem
      infoPackagingItem: {
        label: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.label.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.label.label')
          options: [
            {
              code: 'Master',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.label.options.Master',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.label.options.Master')
            },
            {
              code: 'Single',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.label.options.Single',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.label.options.Single')
            },
            {
              code: 'Helper',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.label.options.Helper',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.label.options.Helper')
            },
          ],
        },
        huNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.huNumber.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.huNumber.label')
        },
        isOuterPackaging: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.isOuterPackaging.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.isOuterPackaging.label')
        },
        selectMaster: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.selectMaster.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.selectMaster.label')
        },
        quantity: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.quantity.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.quantity.label')
        },
        quantityUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.quantityUnit.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.quantityUnit.label')
          options: [
            {
              code: 'PC',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.quantityUnit.options.PC',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.quantityUnit.options.PC')
            },
          ],
        },
        weight: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.weight.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.weight.label')
        },
        weightUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.weightUnit.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.weightUnit.label')
          options: [
            {
              code: 'KG',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.weightUnit.options.KG',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.form.weightUnit.options.KG')
            },
          ],
        },
        batchTable: {
          enabled: true,
          columns: [
            {
              // Batchnumber
              field: 'Batchnumber',

              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.batches.table.columns.batchnumber.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.batches.table.columns.batchnumber.header')
            },
            {
              // Quantity
              field: 'Quantity',
              align: 'right',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.batches.table.columns.quantity.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.batches.table.columns.quantity.header')
            },
            {
              // AvailableQuantity
              field: 'AvailableQuantity',
              align: 'right',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.batches.table.columns.openQuantity.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.batches.table.columns.openQuantity.header')
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageDetails',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageTitle',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageTitle')
          paginator: true,
          rows: 20,
          rowsPerPageOptions: [20, 50, 100],
        },
        packagingTable: {
          enabled: true,
          columns: [
            {
              // PackagingDataId
              field: 'PackagingDataId',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingDataId.filterPlaceholder',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingDataId.filterPlaceholder')
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingDataId.header',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingDataId.header')
              sortable: true,
            },
            {
              // Description
              field: 'Description',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.description.filterPlaceholder',
              ), // t(''masterDataManagement.packagingData.table.columns.description.filterPlaceholder')
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.description.header',
              ), // t(''masterDataManagement.packagingData.table.columns.description.header')
              sortable: true,
            },
            {
              // Type
              field: 'PackagingMaterial',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingMaterial.filterPlaceholder',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingMaterial.filterPlaceholder')
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingMaterial.header',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingMaterial.header')
              sortable: true,
            },
            {
              // TareWeight
              align: 'right',
              field: 'TareWeight.Value',
              filter: true,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.tareWeight.header',
              ), // t(''masterDataManagement.packagingData.table.columns.tareWeight.header')
              sortable: true,
            },
            {
              // TareWeightUnit
              field: 'TareWeight.Unit',
              filter: false,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.tareWeightUnit.header',
              ), // t(''masterDataManagement.packagingData.table.columns.tareWeightUnit.header')
              sortable: false,
            },
            {
              // PackagingIdentifier
              field: 'PackagingIdentifier',
              filter: true,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingIdentifier.header',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingIdentifier.header')
              sortable: true,
            },
            {
              // PropertyIdentifier
              field: 'PropertyIdentifier',
              filter: true,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.propertyIdentifier.header',
              ), // t(''masterDataManagement.packagingData.table.columns.propertyIdentifier.header')
              sortable: true,
            },
            {
              // Stackable
              align: 'center',
              field: 'IsStackable',
              filter: true,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.isStackable.header',
              ), // t(''masterDataManagement.packagingData.table.columns.isStackable.header')
              sortable: true,
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.emptyMessageDetails',
          ), // t(''masterDataManagement.packagingData.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.emptyMessageTitle',
          ), // t(''masterDataManagement.packagingData.table.emptyMessageTitle')
          paginator: true,
          rows: 20,
          rowsPerPageOptions: [20, 50, 100],
          sortField: 'PackagingDataId',
          sortOrder: 1,
          scrollHeight: '70vh',
        },
      },
      // editPackagingItem
      editPackagingItem: {
        label: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.label.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.label.label')
          options: [
            {
              code: 'Master',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.label.options.Master',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.label.options.Master')
            },
            {
              code: 'Single',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.label.options.Single',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.label.options.Single')
            },
            {
              code: 'Helper',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.label.options.Helper',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.label.options.Helper')
            },
          ],
        },
        huNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.huNumber.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.huNumber.label')
          validation: {
            isRequired: false,
          },
        },
        isOuterPackaging: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.isOuterPackaging.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.isOuterPackaging.label')
          validation: {
            isRequired: false,
          },
        },
        selectMaster: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.selectMaster.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.selectMaster.label')
        },
        quantity: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.quantity.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.quantity.label')
          validation: {
            isRequired: true,
          },
        },
        quantityUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.quantityUnit.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.quantityUnit.label')
          options: [
            {
              code: 'PC',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.quantityUnit.options.PC',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.quantityUnit.options.PC')
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        weight: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.weight.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.weight.label')
          validation: {
            isRequired: false,
          },
        },
        weightUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.weightUnit.label',
          ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.weightUnit.label')
          options: [
            {
              code: 'KG',
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.weightUnit.options.KG',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.form.weightUnit.options.KG')
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        batchTable: {
          enabled: true,
          columns: [
            {
              // Batchnumber
              field: 'Batchnumber',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.batches.table.columns.batchnumber.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.batches.table.columns.batchnumber.header')
            },
            {
              // Quantity
              field: 'Quantity',
              align: 'right',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.batches.table.columns.quantity.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.batches.table.columns.quantity.header')
            },
            {
              // AvailableQuantity
              field: 'AvailableQuantity',
              align: 'right',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.batches.table.columns.openQuantity.header',
              ), // t('deliveryForecastDespatchAdvice.shippingDetails.packagingTable.edit.dialog.batches.table.columns.openQuantity.header')
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageDetails',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageTitle',
          ), // t('deliveryForecastDespatchAdvice.articleDetail.confirmationBatches.table.emptyMessageTitle')
          paginator: true,
          rows: 20,
          rowsPerPageOptions: [20, 50, 100],
        },
        packagingTable: {
          enabled: true,
          columns: [
            {
              // PackagingDataId
              field: 'PackagingDataId',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingDataId.filterPlaceholder',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingDataId.filterPlaceholder')
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingDataId.header',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingDataId.header')
              sortable: true,
            },
            {
              // Description
              field: 'Description',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.description.filterPlaceholder',
              ), // t(''masterDataManagement.packagingData.table.columns.description.filterPlaceholder')
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.description.header',
              ), // t(''masterDataManagement.packagingData.table.columns.description.header')
              sortable: true,
            },
            {
              // Type
              field: 'PackagingMaterial',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingMaterial.filterPlaceholder',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingMaterial.filterPlaceholder')
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingMaterial.header',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingMaterial.header')
              sortable: true,
            },
            {
              // TareWeight
              align: 'right',
              field: 'TareWeight.Value',
              filter: true,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.tareWeight.header',
              ), // t(''masterDataManagement.packagingData.table.columns.tareWeight.header')
              sortable: true,
            },
            {
              // TareWeightUnit
              field: 'TareWeight.Unit',
              filter: false,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.tareWeightUnit.header',
              ), // t(''masterDataManagement.packagingData.table.columns.tareWeightUnit.header')
              sortable: false,
            },
            {
              // PackagingIdentifier
              field: 'PackagingIdentifier',
              filter: true,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.packagingIdentifier.header',
              ), // t(''masterDataManagement.packagingData.table.columns.packagingIdentifier.header')
              sortable: true,
            },
            {
              // PropertyIdentifier
              field: 'PropertyIdentifier',
              filter: true,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.propertyIdentifier.header',
              ), // t(''masterDataManagement.packagingData.table.columns.propertyIdentifier.header')
              sortable: true,
            },
            {
              // Stackable
              align: 'center',
              field: 'IsStackable',
              filter: true,
              header: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.columns.isStackable.header',
              ), // t(''masterDataManagement.packagingData.table.columns.isStackable.header')
              sortable: true,
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.emptyMessageDetails',
          ), // t(''masterDataManagement.packagingData.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.emptyMessageTitle',
          ), // t(''masterDataManagement.packagingData.table.emptyMessageTitle')
          paginator: true,
          rows: 20,
          rowsPerPageOptions: [20, 50, 100],
          sortField: 'PackagingDataId',
          sortOrder: 1,
          scrollHeight: '70vh',
        },
      },
      // 6 attachment
      attachment: {
        enabled: true,
        title: getTranslationsForConfig(
          'deliveryForecastDespatchAdvice.attachment.title',
        ), // t('deliveryForecastDespatchAdvice.attachment.title')
        // 6.1 additionalDocuments
        additionalDocuments: {
          enabled: true,
          title: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.attachment.additionalDocuments.title',
          ), // t('deliveryForecastDespatchAdvice.attachment.additionalDocuments.title')
          columns: [
            {
              dataType: 'string',
              enabled: true,
              field: 'Name',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.columns.name.filterPlaceholder',
              ), // t('deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.columns.name.filterPlaceholder')
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.columns.name.header',
              ), // t('deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.columns.name.header')
              width: '400px',
            },
            {
              dataType: 'attachmentCategory',
              enabled: true,
              field: 'Category',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.columns.category.header',
              ), // t('deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.columns.category.header')
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.emptyMessageDetails',
          ), // t('deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.emptyMessageTitle',
          ), // t('deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.emptyMessageTitle')
          paginator: true,
          rows: 5,
          rowsPerPageOptions: [5, 20, 50],
          sortField: 'Name',
          sortOrder: 1,
        },
      },
      // 7 Attachment dialogs
      // 7.1 uploadAttachment
      uploadAttachment: {
        enabled: true,
        // Datei
        attachment: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.upload.dialog.form.attachment.label',
          ), // t('deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.upload.dialog.form.attachment.label')
          readonly: false,
          validation: {
            maxFileSize: 5000000,
            accept: '.doc, .docx, .pdf, .ppt, .pptx, .xls, .xlsx',
          },
        },
        // Kategorie
        category: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.upload.dialog.form.category.label',
          ), // t('deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.upload.dialog.form.category.label')
          options: [
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.upload.dialog.form.category.options.transportDocument.name',
              ), // t('deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.upload.dialog.form.category.options.transportDocument.name')
              code: 'transportDocument',
            },
            {
              name: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.upload.dialog.form.category.options.safetyNotice.name',
              ), // t('deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.upload.dialog.form.category.options.safetyNotice.name')
              code: 'safetyNotice',
            },
          ],
          placeholder: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.upload.dialog.form.category.placeholder',
          ), // t('deliveryForecastDespatchAdvice.attachment.additionalDocuments.table.upload.dialog.form.category.placeholder')
          readonly: false,
          validation: {
            isRequired: true,
          },
        },
      },
      // 8 Delivery forecast despatch advice dialogs
      // 8.1 acceptDeliveryForecastDespatchAdvice
      acceptDeliveryForecastDespatchAdvice: {
        enabled: true,
        deliveryNoteNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.title.send.dialog.form.deliveryNoteNumber.label',
          ), // t('deliveryForecastDespatchAdvice.title.send.dialog.form.deliveryNoteNumber.label')
        },
        deliveryNoteDate: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.title.send.dialog.form.deliveryNoteDate.label',
          ), // t('deliveryForecastDespatchAdvice.title.send.dialog.form.deliveryNoteDate.label')
        },
        deliveryDate: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.title.send.dialog.form.deliveryDate.label',
          ), // t('deliveryForecastDespatchAdvice.title.send.dialog.form.deliveryDate.label')
        },
        table: {
          enabled: true,
          columns: [
            {
              dataType: 'string',
              field: 'BuyerProductId',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.columns.buyerProductId.header',
              ), // t('deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.columns.buyerProductId.header')
            },
            {
              dataType: 'string',
              field: 'BuyerProductDescription',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.columns.buyerProductDescription.header',
              ), // t('deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.columns.buyerProductDescription.header')
            },
            {
              align: 'right',
              dataType: 'number',
              field: 'Quantity',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.columns.quantity.header',
              ), // t('deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.columns.quantity.header')
            },
            {
              align: 'right',
              dataType: 'number',
              field: 'ConfirmationQuantity',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.columns.confirmationQuantity.header',
              ), // t('deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.columns.confirmationQuantity.header')
            },
            {
              dataType: 'deliveryStatus',
              field: 'DeliveryStatus',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.columns.deliveryStatus.header',
              ), // t('deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.columns.deliveryStatus.header')
            },
            {
              dataType: 'status',
              field: 'ConfirmationCode',
              header: getTranslationsForConfig(
                'deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.columns.confirmationCode.header',
              ), // t('deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.columns.confirmationCode.header')
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.emptyMessageDetails',
          ), // t('deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.emptyMessageTitle',
          ), // t('deliveryForecastDespatchAdvice.title.send.dialog.shedules.article.table.emptyMessageTitle')
          paginator: false,
          rows: 5,
          rowsPerPageOptions: [5, 20, 50],
          sortField: 'BuyerProductId',
          sortOrder: 1,
        },
      },
    }
  }
